import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import { filter } from 'rxjs/operators';
import { CreateAlertModal } from 'src/modules/features/setting/modals/app-security-modals/create-alert-modal/create-alert-modal.component';
import { SecurityConfirmationModal } from 'src/modules/features/setting/modals/app-security-modals/security-confirmation-modal/security-confirmation-modal.component';
import { ApplicationSecurityService } from 'src/modules/features/setting/components/application-security/services/application-security.service';

@Component({
  selector: 'app-file-logs',
  templateUrl: './file-logs.component.html',
  styleUrls: ['./file-logs.component.scss'],
})
export class FileLogsComponent implements OnInit {
  filter: AppFilter = new AppFilter({ sidx: 'dateCreated' });
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  logs: Array<any> = [];
  error: any;
  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'eventType',
        op: 'cn',
        data: '',
      },
    ],
  };
  organizationId: string;
  success: any;
  constructor(
    private appSecuritySvc: ApplicationSecurityService,
    private modalService: SuiModalService
  ) {
    this.logs = [];
  }

  ngOnInit(): void {
    this.getPage(1);
  }

  getPage(page: number) {
    this.filter.page = page;
    const logFilter = {
      ...this.filter,
      eventType: 'FILE_UPLOAD',
    };
    console.log('filter ', logFilter);
    this.pending = true;
    this.appSecuritySvc
      .getAllFileUploads({
        params: logFilter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.currentPage = page;
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.logs = res['rows'];
          this.logs = this.logs.map((log) => {
            const metaData = JSON.parse(log.metaData);
            log.logStatus = metaData.status;

            return log;
          });
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  viewLogDetail(log) {}

  openBlacklistIPAddressModal(log) {
    this.modalService
      .open(
        new SecurityConfirmationModal(
          'Blacklist IP Address',
          `Are you sure you want to blacklist this IP address? ${log?.ipAddress}`,
          'Yes'
        )
      )
      .onApprove(() => {
        this.blacklistIpAddress(log);
      })
      .onDeny(() => {});
  }

  blacklistIpAddress(log) {}

  onCreateLogAlertModal(log) {
    this.modalService
      .open(new CreateAlertModal('Create Alert', {}))
      .onApprove(() => {
        this.createLogAlert(log);
      })
      .onDeny(() => {});
  }

  createLogAlert(log) {}

  // searchAd(value) {
  //   this.filter.filters = JSON.stringify(value);
  //   this.filter.page = 1;
  //   this.getPage(this.filter.page);
  // }
  adSearchFilter = {
    groupOp: 'AND',
    rules: [],
  };
  searchAd(event) {
    this.adSearchFilter = event;
    event = Object.assign({}, event);
    this.filter._search = true;
    this.filter.filters = JSON.stringify(event);
    this.filter.page = 1;
    this.getPage(this.filter.page);
  }

  searchRecords(search) {
    if (search === '') {
      this.filter = new AppFilter({ sidx: 'dateCreated' });
      this.getPage(this.filter.page);
    } else {
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'username',
            op: 'cn',
            data: '',
          },
          {
            field: 'action',
            op: 'cn',
            data: '',
          },
        ],
      };
      searchFilter.rules[0].data = search;
      searchFilter.rules[1].data = search;
      this.filter.filters = JSON.stringify(searchFilter);
      this.getPage(1);
    }
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'firstName';
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    console.log('page ', page);
    this.getPage(this.currentPage);
  }
}
